import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import SalesDashboard from './Sales/SalesDashboard';
import Cookies from 'js-cookie';
import EngDashboard from './Engineer/EngDashboard';
import InventoryDashboard from './Inventory/InventoryDashboard';
import ManagementDashboard from './Management/ManagementDashboard';
import MarketingDashboard from './MarketingDashboard';
import { isBuilderAccountOwner } from '../components/ai/aiVerticalScope';
import { isManagementVerticalSession, isSalesVerticalSession } from '../../shared/utils/authStorage';

const Dashboard = () => {
  const [userVertical, setUserVertical] = useState();
  const isBuilder = isBuilderAccountOwner();

  useEffect(() => {
    const syncVertical = () => setUserVertical(Cookies.get('userVertical'));
    syncVertical();
    window.addEventListener('userLoggedIn', syncVertical);
    window.addEventListener('sessionProfileSynced', syncVertical);
    return () => {
      window.removeEventListener('userLoggedIn', syncVertical);
      window.removeEventListener('sessionProfileSynced', syncVertical);
    };
  }, []);

  /** Sales users (including managers) belong on the sales workspace, not admin dashboards. */
  if (isSalesVerticalSession()) {
    return <Navigate to="/builder/sales" replace />;
  }

  /** Builder main dashboard — portfolio hub with all AI vertical lenses. */
  if (isBuilder) {
    return <ManagementDashboard portfolioMode />;
  }

  return (
    <>
      {isManagementVerticalSession() && <ManagementDashboard />}
      {userVertical === 'Sales' && <SalesDashboard />}
      {userVertical === 'Operations' && <EngDashboard />}
      {userVertical === 'Inventory' && <InventoryDashboard />}
      {userVertical === 'Marketing' && <MarketingDashboard />}
    </>
  );
};

export default Dashboard;
